import axios from 'axios';

const DeliveryService = {
  getAll() {
    return axios.get('deliveryMethod').catch((error) => {
      throw new Error(`deliveryMethod.getAll ${error}`);
    });
  },
  get(id) {
    return axios.get(`deliveryMethod/${id}`).catch((error) => {
      throw new Error(`deliveryMethod.get ${error}`);
    });
  },
};

export default DeliveryService;
